import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Umbrella, FileCheck2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { Cm3Badge } from "./Cm3Badge";
import { CM3 } from "../data/compliance";

const FACTS = [
  { icon: ShieldCheck, label: "Cm3 Prequalified", value: `ID ${CM3.id}` },
  { icon: Umbrella, label: "Public Liability", value: CM3.publicLiability },
  { icon: FileCheck2, label: "WHS System", value: "Independently verified" },
];

export default function ComplianceBand() {
  return (
    <section className="mx-auto max-w-7xl px-5 md:px-10 pb-8" data-testid="home-compliance-band">
      <Reveal>
        <div className="relative overflow-hidden rounded-lg border border-gold/30 bg-obsidian-800">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
          <div className="grid gap-8 p-7 md:grid-cols-[auto_1fr_auto] md:items-center md:p-9">
            <Cm3Badge size="lg" />
            <ul className="grid gap-5 sm:grid-cols-3">
              {FACTS.map(({ icon: Icon, label, value }) => (
                <li key={label} className="flex items-start gap-3">
                  <Icon size={18} className="mt-0.5 shrink-0 text-gold" />
                  <span>
                    <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{label}</span>
                    <span className="block font-heading font-bold text-white">{value}</span>
                  </span>
                </li>
              ))}
            </ul>
            <Link to="/compliance" data-testid="home-compliance-link"
                  className="inline-flex items-center gap-2 whitespace-nowrap font-mono text-xs uppercase tracking-widest text-gold hover:text-gold-hover">
              Compliance &amp; safety <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
